/* Oceanis — cart & product recommendations ("¿Te has olvidado de algo?" + "Comprados juntos habitualmente") */
(function () {
  if (window.OlvRecs) return;

  var base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var cache = {};

  function money(cents, el) {
    var cur = (el && el.dataset.currency) || 'EUR';
    var loc = (el && el.dataset.locale) || document.documentElement.lang || 'es';
    try {
      return new Intl.NumberFormat(loc, { style: 'currency', currency: cur }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2) + ' ' + cur;
    }
  }
  function esc(s) {
    var d = document.createElement('div');
    d.textContent = s == null ? '' : String(s);
    return d.innerHTML;
  }
  function img(src, w) {
    if (!src) return '';
    if (typeof src === 'object') src = src.src || src.url || '';
    if (src.indexOf('//') === 0) src = 'https:' + src;
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + (w || 300);
  }
  function recs(id, intent, limit) {
    var key = id + '|' + intent + '|' + limit;
    if (!cache[key]) {
      cache[key] = fetch(base + 'recommendations/products.json?product_id=' + id + '&limit=' + limit + '&intent=' + intent)
        .then(function (r) { return r.ok ? r.json() : { products: [] }; })
        .then(function (d) { return d.products || []; })
        .catch(function () { return []; });
    }
    return cache[key];
  }
  function firstAvailable(p) {
    var v = (p.variants || []).filter(function (x) { return x.available; });
    return v[0] || (p.variants || [])[0];
  }
  function collect(lists, exclude, limit) {
    var seen = {}, out = [];
    var max = Math.max.apply(null, lists.map(function (l) { return l.length; }).concat([0]));
    for (var i = 0; i < max && out.length < limit; i++) {
      lists.forEach(function (l) {
        var p = l[i];
        if (!p || out.length >= limit || seen[p.id] || exclude.indexOf(p.id) > -1 || !p.available) return;
        seen[p.id] = true;
        out.push(p);
      });
    }
    return out;
  }
  function getRecs(ids, limit, fallback) {
    return Promise.all(ids.map(function (id) { return recs(id, 'complementary', limit); })).then(function (lists) {
      var picked = collect(lists, ids, limit);
      if (picked.length >= limit || !fallback) return picked;
      return Promise.all(ids.map(function (id) { return recs(id, 'related', limit); })).then(function (rel) {
        return collect(lists.concat(rel), ids, limit);
      });
    });
  }
  function variantSelect(p, el) {
    var opts = (p.variants || []).filter(function (v) { return v.available; }).map(function (v) {
      return '<option value="' + v.id + '" data-price="' + v.price + '">' + esc(v.title) + ' — ' + money(v.price, el) + '</option>';
    }).join('');
    return '<select class="olv-select" aria-label="' + esc(p.title) + '">' + opts + '</select>';
  }

  /* ---------- add to cart + refresh the theme's cart UI ---------- */
  function addToCart(items) {
    // On the cart page refresh the page itself; elsewhere open the cart drawer.
    var cartItems = document.getElementById('main-cart-items') ? document.querySelector('cart-items') : null;
    var drawer = cartItems ? null : document.querySelector('cart-drawer');
    var sections = [];
    if (cartItems && cartItems.getSectionsToRender) sections = cartItems.getSectionsToRender().map(function (s) { return s.section; });
    else if (drawer) sections = ['cart-drawer', 'cart-icon-bubble'];
    else sections = ['cart-icon-bubble'];

    return fetch(base + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items, sections: sections, sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json().then(function (d) { if (!r.ok) throw d; return d; }); })
      .then(function (res) {
        var s = res.sections || {};
        if (drawer && drawer.renderContents) {
          drawer.classList.remove('is-empty');
          drawer.renderContents({ id: items[0].id, sections: s });
        } else if (cartItems && cartItems.getSectionsToRender) {
          cartItems.getSectionsToRender().forEach(function (sec) {
            var host = document.getElementById(sec.id);
            if (!host || !s[sec.section]) return;
            var target = host.querySelector(sec.selector) || host;
            var src = new DOMParser().parseFromString(s[sec.section], 'text/html').querySelector(sec.selector);
            if (src) target.innerHTML = src.innerHTML;
          });
          var footer = document.getElementById('main-cart-footer');
          if (footer) footer.classList.remove('is-empty');
          cartItems.classList.remove('is-empty');
        } else {
          window.location.href = base + 'cart';
          return res;
        }
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'olv-recs', cartData: res });
        }
        return res;
      });
  }

  function setBusy(btn, busy, doneText) {
    if (busy) {
      btn.dataset.label = btn.innerHTML;
      btn.disabled = true;
      btn.classList.add('olv-busy');
    } else {
      btn.disabled = false;
      btn.classList.remove('olv-busy');
      btn.innerHTML = doneText || btn.dataset.label;
    }
  }

  /* ---------- <olv-recs>: "¿Te has olvidado de algo?" (cart drawer + cart page) ---------- */
  class OlvRecs extends HTMLElement {
    connectedCallback() {
      this.limit = parseInt(this.dataset.limit, 10) || 4;
      this.list = this.querySelector('.olv-recs__list');
      this.ids = (this.dataset.ids || '').split(',').filter(Boolean).map(Number);
      this.load();
      var self = this;
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsub = subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
          if (!self.isConnected || self.closest('cart-drawer')) return; // drawer re-renders itself
          fetch(base + 'cart.js').then(function (r) { return r.json(); }).then(function (cart) {
            self.ids = cart.items.map(function (i) { return i.product_id; }).filter(function (v, i, a) { return a.indexOf(v) === i; });
            self.load();
          });
        });
      }
      this.addEventListener('click', this.onClick.bind(this));
      this.addEventListener('change', this.onChange.bind(this));
    }
    disconnectedCallback() { if (this.unsub) this.unsub(); }
    load() {
      var self = this;
      if (!this.ids.length) { this.hidden = true; return; }
      getRecs(this.ids, this.limit, this.dataset.fallback !== 'false').then(function (products) {
        if (!products.length) { self.hidden = true; return; }
        self.render(products);
        self.hidden = false;
      });
    }
    render(products) {
      var el = this;
      var btn = this.dataset.button || 'Añadir';
      this.list.innerHTML = products.map(function (p) {
        var v = firstAvailable(p);
        var multi = (p.variants || []).filter(function (x) { return x.available; }).length > 1;
        var cmp = p.compare_at_price && p.compare_at_price > v.price
          ? '<s class="olv-cmp">' + money(p.compare_at_price, el) + '</s>' : '';
        var save = p.compare_at_price && p.compare_at_price > v.price
          ? '<span class="olv-badge">-' + Math.round((1 - v.price / p.compare_at_price) * 100) + '%</span>' : '';
        return '<li class="olv-card">' +
          '<a class="olv-card__media" href="' + p.url + '">' + save +
            (p.featured_image ? '<img loading="lazy" src="' + img(p.featured_image, 300) + '" alt="' + esc(p.title) + '" width="150" height="150">' : '') +
          '</a>' +
          '<div class="olv-card__info">' +
            '<a class="olv-card__title" href="' + p.url + '">' + esc(p.title) + '</a>' +
            '<div class="olv-card__price"><span class="olv-price" data-price>' + money(v.price, el) + '</span>' + cmp + '</div>' +
            (multi ? variantSelect(p, el) : '') +
            '<button type="button" class="olv-add" data-variant="' + v.id + '">' +
              '<span aria-hidden="true">+</span> ' + esc(btn) +
            '</button>' +
          '</div>' +
        '</li>';
      }).join('');
    }
    onChange(e) {
      var sel = e.target.closest('.olv-select');
      if (!sel) return;
      var card = sel.closest('.olv-card');
      var opt = sel.options[sel.selectedIndex];
      card.querySelector('.olv-add').dataset.variant = sel.value;
      card.querySelector('[data-price]').textContent = money(parseInt(opt.dataset.price, 10), this);
    }
    onClick(e) {
      var b = e.target.closest('.olv-add');
      if (!b || b.disabled) return;
      var self = this;
      setBusy(b, true);
      addToCart([{ id: parseInt(b.dataset.variant, 10), quantity: 1 }])
        .then(function () { if (b.isConnected) setBusy(b, false, '✓ ' + (self.dataset.added || 'Añadido')); })
        .catch(function (err) {
          setBusy(b, false);
          alert((err && (err.description || err.message)) || 'No se pudo añadir el producto.');
        });
    }
  }
  if (!customElements.get('olv-recs')) customElements.define('olv-recs', OlvRecs);

  /* ---------- <olv-fbt>: "Comprados juntos habitualmente" (product page) ---------- */
  class OlvFbt extends HTMLElement {
    connectedCallback() {
      var self = this;
      this.limit = parseInt(this.dataset.limit, 10) || 2;
      try { this.main = JSON.parse(this.querySelector('script[type="application/json"]').textContent); } catch (e) { return; }
      recs(this.main.product_id, 'complementary', this.limit + 2).then(function (list) {
        var items = list.filter(function (p) { return p.available && p.id !== self.main.product_id; }).slice(0, self.limit);
        if (!items.length) return;
        self.others = items;
        self.render();
        self.hidden = false;
      });
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsub = subscribe(PUB_SUB_EVENTS.variantChange, function (ev) {
          var v = ev && ev.data && ev.data.variant;
          if (!v || !self.others) return;
          self.main.variant_id = v.id;
          self.main.price = v.price;
          self.main.available = v.available;
          self.update();
        });
      }
      this.addEventListener('change', function (e) {
        if (e.target.matches('.olv-select')) {
          var row = e.target.closest('[data-row]');
          var opt = e.target.options[e.target.selectedIndex];
          row.dataset.variant = e.target.value;
          row.dataset.price = opt.dataset.price;
          row.querySelector('[data-price]').textContent = money(parseInt(opt.dataset.price, 10), self);
        }
        self.update();
      });
      this.addEventListener('click', function (e) {
        var b = e.target.closest('.olv-fbt__add');
        if (b) self.addAll(b);
      });
    }
    disconnectedCallback() { if (this.unsub) this.unsub(); }
    render() {
      var el = this, m = this.main;
      var all = [{ id: m.product_id, title: m.title, url: null, image: m.image, variant: m.variant_id, price: m.price, main: true }]
        .concat(this.others.map(function (p) {
          var v = firstAvailable(p);
          return { id: p.id, title: p.title, url: p.url, image: p.featured_image, variant: v.id, price: v.price, p: p };
        }));
      this.querySelector('.olv-fbt__images').innerHTML = all.map(function (it, i) {
        return (i ? '<span class="olv-fbt__plus" aria-hidden="true">+</span>' : '') +
          '<' + (it.url ? 'a href="' + it.url + '"' : 'span') + ' class="olv-fbt__img" data-img="' + i + '">' +
          (it.image ? '<img loading="lazy" src="' + img(it.image, 300) + '" alt="' + esc(it.title) + '" width="120" height="120">' : '') +
          '</' + (it.url ? 'a' : 'span') + '>';
      }).join('');
      this.querySelector('.olv-fbt__rows').innerHTML = all.map(function (it, i) {
        var multi = it.p && (it.p.variants || []).filter(function (x) { return x.available; }).length > 1;
        return '<li class="olv-fbt__row" data-row="' + i + '" data-variant="' + it.variant + '" data-price="' + it.price + '">' +
          '<label class="olv-fbt__check"><input type="checkbox" checked data-check="' + i + '">' +
          '<span class="olv-fbt__name">' + (it.main ? '<strong>' + esc(el.dataset.thisItem || 'Este artículo') + ':</strong> ' + esc(it.title)
            : '<a href="' + it.url + '">' + esc(it.title) + '</a>') + '</span></label>' +
          (multi ? variantSelect(it.p, el) : '') +
          '<span class="olv-fbt__price" data-price>' + money(it.price, el) + '</span>' +
        '</li>';
      }).join('');
      this.update();
    }
    update() {
      var el = this, total = 0, n = 0;
      var mainRow = this.querySelector('[data-row="0"]');
      if (mainRow) {
        mainRow.dataset.variant = this.main.variant_id;
        mainRow.dataset.price = this.main.price;
        mainRow.querySelector('[data-price]').textContent = money(this.main.price, el);
      }
      this.querySelectorAll('[data-row]').forEach(function (row) {
        var on = row.querySelector('[data-check]').checked;
        var i = row.dataset.row;
        var pic = el.querySelector('[data-img="' + i + '"]');
        if (pic) pic.classList.toggle('is-off', !on);
        if (on) { total += parseInt(row.dataset.price, 10); n++; }
      });
      this.querySelector('[data-total]').textContent = money(total, el);
      var btn = this.querySelector('.olv-fbt__add');
      btn.disabled = n === 0 || (this.main.available === false && this.querySelector('[data-check="0"]').checked);
      btn.textContent = n <= 1 ? (el.dataset.add1 || 'Añadir al carrito')
        : n === 2 ? (el.dataset.add2 || 'Añadir ambos al carrito')
        : (el.dataset.addN || 'Añadir los [n] al carrito').replace('[n]', n);
    }
    addAll(btn) {
      var items = [];
      this.querySelectorAll('[data-row]').forEach(function (row) {
        if (row.querySelector('[data-check]').checked) items.push({ id: parseInt(row.dataset.variant, 10), quantity: 1 });
      });
      if (!items.length) return;
      setBusy(btn, true);
      var self = this;
      addToCart(items)
        .then(function () { setBusy(btn, false); self.update(); })
        .catch(function (err) {
          setBusy(btn, false);
          alert((err && (err.description || err.message)) || 'No se pudo añadir al carrito.');
        });
    }
  }
  if (!customElements.get('olv-fbt')) customElements.define('olv-fbt', OlvFbt);

  window.OlvRecs = { addToCart: addToCart };
})();
